import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueResource from 'vue-resource';
Vue.config.productionTip = false
import BASE_URL from "@/views/baseURL";

Vue.use(ElementUI);
Vue.use(VueResource);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
